import React, { useState, useRef, useEffect } from "react";
import {
  Modal,
  Form,
  Row,
  Col,
  Overlay,
  Popover,
  Button,
} from "react-bootstrap";
import ReactSelect from "react-select";
import "bootstrap/dist/css/bootstrap.min.css";
import Flatpickr from "react-flatpickr";
import { fetchCityData, selectCity } from "../../redux/actions/citiesAction";
import {
  fetchIndustryData,
  setSelectedIndustry,
} from "../../redux/actions/industryActions";
import { useDispatch, useSelector } from "react-redux";

import { customStyles } from "../../selectStyles";
import axios from "../../API/axios";
import toast from "react-hot-toast";
import {
  fetchInstituteData,
  selectGetInstitute,
} from "../../redux/actions/getInstitutesAction";
import { useParams } from "react-router-dom";
import {
  fetchSpecialization,
  selectSpecialization,
} from "../../redux/actions/specializationAction";
import {
  fetchQualification,
  selectQualification,
} from "../../redux/actions/qualificationAction";
import moment from "moment/moment";
import CloseSharpIcon from "@mui/icons-material/CloseSharp";

const AddEducation = ({ show, handleClose, userDataId, userDataInfo, getUserCv }) => {
  const sessionId = localStorage.getItem("sessionId");
  const userType = localStorage.getItem("userType");
  const { CandidateId } = useParams();
  //   console.log("JobId", JobId);
  const [display, setDisplay] = useState(false);

  const [field, setField] = useState("");
  const [AcademicAchiv, setAcademicAchiv] = useState("");
  const [grade, setGrade] = useState("");
  const [isPresent, setIsPresent] = useState(false);
  const [description, setDescription] = useState("");
  const [activities, setActivities] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [showTooltip, setShowTooltip] = useState(false);
  const targetRef = useRef(null);
  const [newEducation, setNewEducation] = useState("");
  const [OrganizationName, setOrganizationName] = useState("");
  const [InsName, setInsName] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setDisplay(true);
    const body = {
      sessionId: sessionId,
      userDataId: userDataId,
      userType: userType,
      instnCnddtID: CandidateId === "Candidate" ? null : CandidateId,
      institutionId: instituteId,
      orgType: instituteId === null ? newOrgType : orgType,
      gnrlOrgInsttnId: getOrgInsTId, 
      startYear: startDate === "" ? "" : moment(startDate).format("YYYY"),
      endYear: endDate === "" ? "" : moment(endDate).format("YYYY"),
      qualification: qualification,
      specilization: specialization,
      grade: grade,
      description: description,
      cityId: citySearch,
      startMonth: startDate === "" ? "" : moment(startDate).format("MM"),
      isPresent: isPresent,
      endMonth: endDate === "" ? "" : moment(endDate).format("MM"),
    };
    console.log("body", body);
    if (
      (instituteId === '' && getOrgInsTId === '') ||
      (orgType === '' && newOrgType === '') ||
      AcademicAchiv === '' ||
      // field === '' ||
      citySearch === '' ||
      startDate === ''
    ) {
      toast.error('Please fill all the required fields');
    } else {
      try {
        const res = await axios.post("/Resume/AddEducation", body);
        console.log("res=====>", res);

        toast.success(res.data.message);
        handleClose();
        getUserCv()
        // setField("");
        setAcademicAchiv("");
        setGrade("");
        setDescription("");
        setStartDate(null);
        setEndDate(null);
        setQualification("");
        setSpecialization("");
        setCitySearch("");
        setOrgCity("");
        setInstituteId("");
        setDisplay(false)
        setIsPresent(false)
      } catch (error) {
        if (error.response && error.response.status === 404) {
          toast.warning(error.response.data.message);
        } else {
          toast.error(error.response?.data?.message || "An error occurred");
        }
        // }
      }
    };
  }

    const [getOrgInsTId, setGenOrgInstId] = useState(null);
    const [newOrgType, setnewOrgType] = useState(null);

    const handleSaveInstitution = async () => {
      // setDisplay(true);

      const formData = new FormData();
      formData.append("orgName", OrganizationName);
      formData.append("OrgType", "UnRegdInstitution");
      formData.append("CityID", orgCity);
      formData.append("OrgLogo", fileName);
      formData.append("sessionId", sessionId);
      console.log("formData", formData);

      try {
        const res = await axios.post("/CandidateData/AddGnrlOrgData", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
        console.log("res", res);
        setGenOrgInstId(res.data.responseData.id);
        setnewOrgType(res.data.responseData.value);
        toast.success(res.data.message);
        setShowTooltip(false);
        setOrganizationName("");
        setOrgCity(null);
        setFileName("");
      } catch (error) {
        if (error.response && error.response.status === 404) {
          toast.warning(error.response.data.message);
        } else {
          toast.error(error.response?.data?.message || "An error occurred");
        }
      }
    };
    // ...............................City DDL.......................................
    const [orgCity, setOrgCity] = useState(null);
    const [citySearch, setCitySearch] = useState("");
    const dispatch = useDispatch();
    const { cityList, selectedcityId } = useSelector((state) => state.cities);
    useEffect(() => {
      dispatch(fetchCityData());
    }, [dispatch]);

    const handleCitySelect = (selectedOption) => {
      if (selectedOption) {
        // dispatch(selectCity(selectedOption.value));
        setCitySearch(selectedOption.value);
      }
    };
    const handleCitySelect1 = (selectedOption) => {
      if (selectedOption) {
        setOrgCity(selectedOption.value);
      }
    };
    // ...............................City DDL.......................................

    // ...............................Specialization DDL.......................................
    const [specialization, setSpecialization] = useState("");
    const { SpecializationList, selectedSpecializationId } = useSelector(
      (state) => state.specialization
    );
    useEffect(() => {
      dispatch(fetchSpecialization());
    }, [dispatch]);

    const handleSpecializationSelect = (selectedOption) => {
      if (selectedOption) {
        // dispatch(selectSpecialization(selectedOption.value));
        setSpecialization(selectedOption.label);
        // dispatch(selectSpecialization(selectedOption.label));
      }
    };

    // ...............................Qualification DDL.......................................
    const [qualification, setQualification] = useState("");
    const { qualficationList, selectedqualficationId } = useSelector(
      (state) => state.qualification
    );
    useEffect(() => {
      dispatch(fetchQualification());
    }, [dispatch]);
    const handleQualificationSelect = (selectedOption) => {
      if (selectedOption) {
        // dispatch(selectQualification(selectedOption.value));
        setQualification(selectedOption.label);
      }
    };

    // ...............................Institute DDL.......................................
    const [orgType, setOrgType] = useState("");
    const [instituteId, setInstituteId] = useState(null);
    const { getinstituteList, selectedinstituteId } = useSelector(
      (state) => state.institute
    );
    useEffect(() => {
      dispatch(fetchInstituteData());
    }, [dispatch]);

    const handleInstitute = (selectedOption) => {
      console.log("selectedOption", selectedOption);

      if (selectedOption) {
        // dispatch(selectGetInstitute(selectedOption.value));
        setInstituteId(selectedOption.value);
        setOrgType(selectedOption.tag);
      }
    };

    const toggleTooltip = () => {
      console.log("Toggling Tooltip");
      setShowTooltip((prev) => !prev);
    };
    // ...............................Institute DDL.......................................

    const [fileName, setFileName] = useState(""); // State to store selected filename
    const handleFileChange = (event) => {
      const file = event.target.files[0]; // Get the selected file
      if (file) {
        setFileName(file.name); // Set the filename in state
      }
    };

    const [instituteName, setInstituteName] = useState("");
    const [cityName, setCityName] = useState("");
    const [specializationName, setSpecializationName] = useState("");
    const [qualificationName, setQualificationName] = useState("");
    return (
      <Modal
        show={show}
        onHide={handleClose}
        centered
        size="lg"
        className="add-education"
      >
        <Modal.Header>
          <Modal.Title>Add Education</Modal.Title>
          <CloseSharpIcon className="pointer" onClick={handleClose} />
        </Modal.Header>
        <Modal.Body className="settings">
          <Row>
            {/* Institution and City */}
            <Col md={6}>
              <Form.Group controlId="institution">
                <Form.Group controlId="Industry">
                  <Form.Label className="class-type">
                    Institute
                    <span style={{ color: "red" }} className="ms-2">
                      *
                    </span>
                  </Form.Label>
                  {InsName !== "" ? (
                    <div>
                      <input
                        type="text"
                        value={InsName}
                        placeholder="Enter Org name"
                        className="mb-2 form-control Dark-Input-from-group"
                        disabled
                      />
                    </div>
                  ) : (
                    <div className="post-form-group mb-0">
                      <ReactSelect
                        options={getinstituteList}
                        onChange={handleInstitute}
                        value={
                          getinstituteList.find(
                            (option) => option.value === instituteId
                          ) || null
                        }
                        //   onInputChange={(inputValue) => {
                        //     setInstituteName(inputValue);
                        //   }}
                        placeholder="Select Institute"
                        classNamePrefix="react-select"
                        className="form-control"
                        styles={customStyles}
                      />
                    </div>
                  )}
                </Form.Group>
                {display && !instituteId ? (
                  <span className="error_msg_lbl">Select Institute </span>
                ) : null}
                <a
                  href="#"
                  ref={targetRef}
                  onClick={(e) => {
                    e.preventDefault();
                    toggleTooltip();
                  }}
                  className="createModal"
                // isDisabled={!selectedIndustryId} // Disable until industry is selected
                >
                  Create New
                </a>
                <Overlay
                  target={targetRef.current}
                  show={showTooltip}
                  placement="right"
                  rootClose
                  container={document.querySelector(".modal")}
                  onHide={() => setShowTooltip(false)} // Close when clicking outside
                >
                  <Popover id="popover-basic">
                    <Popover.Header as="h3" className="Dark-Body-Card-group">Create Institute</Popover.Header>
                    <Popover.Body className="Dark-Body-Card-group">
                      <Form>
                        <div>
                          <label className="mb-1 Text-mb-Create">Institute name</label>
                          <input
                            type="text"
                            value={OrganizationName}
                            onChange={(e) => {
                              setOrganizationName(e.target.value);
                              setInsName(e.target.value);
                            }}
                            placeholder="Enter Institute name"
                            className="mb-2 form-control Dark-Input-from-group"
                          />
                        </div>
                        <div>
                          <label className="mb-1 Text-mb-Create">City</label>
                          <ReactSelect
                            options={cityList}
                            onChange={handleCitySelect1}
                            value={
                              cityList.find(
                                (option) => option.value === orgCity
                              ) || null
                            }
                            placeholder="Select City"
                            classNamePrefix="react-select"
                            className="form-control Dark-Input-from-group"
                            styles={customStyles}
                          />
                        </div>
                        <div className=" mt-2 mb-2 Text-mb-Create">
                          <label className="mb-1">Institute Logo</label>
                          <input
                            type="file"
                            id="lastName"
                            className="form-control Dark-Input-from-group"
                            placeholder=""
                            onChange={handleFileChange}
                          //   onChange={(e) => {
                          //     handleProfileImageChange(e);
                          //   }}
                          //   invalid={displays && profileImage === ""}
                          />
                          {/* {displays && !profileImage ? (
                          <span className="error_msg_lbl text-red">
                            Upload Image{" "}
                          </span>
                        ) : null} */}
                        </div>
                        <div className="d-flex justify-content-end">
                          <Button
                            variant="primary"
                            size="sm"
                            onClick={handleSaveInstitution}
                            className="me-2"
                          >
                            Save
                          </Button>
                          <Button
                            variant="secondary"
                            size="sm"
                            onClick={() => setShowTooltip(false)}
                          >
                            Cancel
                          </Button>
                        </div>
                      </Form>
                    </Popover.Body>
                  </Popover>
                </Overlay>
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group controlId="city">
                <Form.Label className="class-type">
                  City
                  <span style={{ color: "red" }} className="ms-2">
                    *
                  </span>
                </Form.Label>
              </Form.Group>
              <div className="post-form-group mb-0">
                <ReactSelect
                  options={cityList}
                  onChange={handleCitySelect}
                  value={
                    cityList.find((option) => option.value === citySearch) || null
                  }
                  // onInputChange={(inputValue) => {
                  //   setCityName(inputValue);
                  // }}
                  placeholder="Select City"
                  classNamePrefix="react-select"
                  className="form-control"
                  styles={customStyles}
                />
              </div>
              {display && !citySearch ? (
                <span className="error_msg_lbl">Select City </span>
              ) : null}
            </Col>



            <Col md={6} className="mb-2">
              <Form.Group controlId="grade">
                <Form.Label className="class-type">Grade</Form.Label>
                <Form.Control
                  type="text"
                  value={grade}
                  className="custom-style Dark-Input-from-group"
                  onChange={(e) => setGrade(e.target.value)}
                  placeholder="Enter Grade"
                />
                {/* {display && !grade ? (
                <span className="error_msg_lbl">Select Grade </span>
              ) : null} */}
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group controlId="AcademicAchiv">
                <Form.Label className="class-type">
                  Academic  Achievements<span style={{ color: "red" }}>*</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  value={AcademicAchiv}
                  className="custom-style Dark-Input-from-group"
                  onChange={(e) => setAcademicAchiv(e.target.value)}
                  placeholder="Enter Academic Achivement"
                />
                {display && !AcademicAchiv ? (
                  <span className="error_msg_lbl">Select Academic Achivement </span>
                ) : null}
              </Form.Group>
            </Col>

            {/* Start Year, End Year, Is Present */}
            <Col md={6}>
              <Form.Group controlId="grade">
                <Form.Label className="class-type">Activities and Achievements</Form.Label>
                <Form.Control
                  type="text"
                  value={activities}
                  className="custom-style Dark-Input-from-group"
                  onChange={(e) => setActivities(e.target.value)}
                  placeholder="Enter Activites"
                />
                {display && !activities ? (
                  <span className="error_msg_lbl">Select Activities and Achievements </span>
                ) : null}
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group controlId="city">
                <Form.Label className="class-type">
                  Specialization
                  {/* <span style={{ color: "red" }} className="ms-2">
                  *
                </span> */}
                </Form.Label>
              </Form.Group>
              <div className="post-form-group mb-0">
                <ReactSelect
                  options={SpecializationList}
                  onChange={handleSpecializationSelect}
                  value={
                    SpecializationList.find(
                      (option) => option.label === specialization
                      // (option) => option.label === selectedSpecializationId
                    ) || null
                  }
                  // onInputChange={(inputValue) => {
                  //   setSpecializationName(inputValue);
                  // }}
                  placeholder="Select Specialization"
                  classNamePrefix="react-select"
                  className="form-control"
                  styles={customStyles}
                />
              </div>
              {/* {display && !specializationName ? (
              <span className="error_msg_lbl">Select Specialization </span>
            ) : null} */}
            </Col>

            <Col md={6}>
              <Form.Group controlId="city">
                <Form.Label className="class-type">
                  Qualification
                  {/* <span style={{ color: "red" }} className="ms-2">
                  *
                </span> */}
                </Form.Label>
              </Form.Group>
              <div className="post-form-group mb-0">
                <ReactSelect
                  options={qualficationList}
                  onChange={handleQualificationSelect}
                  value={
                    qualficationList.find(
                      (option) => option.label === qualification
                      // (option) => option.label === selectedqualficationId
                    ) || null
                  }
                  placeholder="Select Qualification"
                  classNamePrefix="react-select"
                  className="form-control"
                  styles={customStyles}
                />
              </div>
              {/* {display && !qualificationName ? (
              <span className="error_msg_lbl">Select Qualification </span>
            ) : null} */}
            </Col>

            <Col md={6} className="mb-0 mt-2">
              <Form.Group controlId="endYear">
                <Form.Label className="class-type">
                  Start Year
                  <span style={{ color: "red" }} className="ms-2">
                    *
                  </span>
                </Form.Label>
                <Flatpickr
                  type="number"
                  value={startDate}
                  className="custom-style"
                  onChange={(date) => setStartDate(date[0])}
                  placeholder="Enter Start Year"
                // disabled={isPresent}
                />
              </Form.Group>
              {display && !startDate ? (
                <span className="error_msg_lbl">Enter Start Year</span>
              ) : null}
            </Col>
            {userDataInfo.isPresentEducation === true ? (
              ""
            ) : (
              <Col md={6} className="d-flex align-items-center">
                <Form.Check
                  type="checkbox"
                  label="Is Present"
                  checked={isPresent}
                  onChange={(e) => setIsPresent(e.target.checked)}
                />
              </Col>
            )}

            {isPresent === false ? (
              <Col md={6} className="mb-2 mt-2">
                <Form.Group controlId="endYear">
                  <Form.Label className="class-type">
                    End Year
                    {/* <span style={{ color: "red" }} className="ms-2">
                    *
                  </span> */}
                  </Form.Label>
                  <Flatpickr
                    type="number"
                    value={endDate}
                    onChange={(date) => setEndDate(date[0])}
                    placeholder="Enter End Year"
                    disabled={isPresent}
                    className="custom-style"
                    options={{
                      minDate: startDate || null, // Set minDate to startDate
                    }}
                  />
                  {/* {display && !endDate ? (
                  <span className="error_msg_lbl">Enter End Year</span>
                ) : null} */}
                </Form.Group>
              </Col>
            ) : (
              ""
            )}

            {/* Description */}
            <Col md={12}>
              <Form.Group controlId="description">
                <Form.Label className="class-type">Description</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  value={description}
                  className="custom-style Dark-Input-from-group"
                  onChange={(e) => setDescription(e.target.value)}
                  placeholder="Enter Description"
                />
              </Form.Group>
            </Col>
          </Row>

          {/* Submit Button */}
          <div className="d-flex justify-content-end mt-4">
            {/* <Button variant="secondary" onClick={handleClose} className="me-3">
                        Close
                    </Button> */}
            <div className="add-class-submit-button mt-4 d-flex justify-content-center">
              <div className="khojPrimaryBtn ms-3">
                <a href="#/" className="" onClick={handleSubmit}>
                  Submit
                </a>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    );
  };


  export default AddEducation;
